'use client';
import { IconCheck, IconEdit } from '@tabler/icons-react';
import { ReactNode } from 'react';
import { useToggle } from '../hooks';

export const EditableInput = ({
  children,
  label,
  value,
  disabled = false,
}: {
  children?: ReactNode;
  value: string;
  label: string;
  disabled?: boolean;
}) => {
  const [edit, toggleEdit] = useToggle();

  const renderIcon = () => {
    if (disabled) {
      return null;
    }

    if (edit) {
      return (
        <div className="w-1/6">
          <IconCheck
            className="cursor-pointer"
            color="#038747"
            width={20}
            height={20}
            onClick={() => toggleEdit()}
          />
        </div>
      );
    }

    return (
      <div className="w-1/6">
        <IconEdit
          className="cursor-pointer"
          color="#98a1b4"
          width={20}
          height={20}
          onClick={() => toggleEdit()}
        />
      </div>
    );
  };

  return (
    <div className="w-full">
      {edit ? (
        <div className="flex w-full gap-2">
          <div className="w-5/6">{children}</div>
          {renderIcon()}
        </div>
      ) : (
        <div className="flex w-full gap-2">
          <div className="w-5/6">
            <span className="text-text-secondary font-bold">{label}: </span>
            <span className="text-text-secondary">{value}</span>
          </div>
          {renderIcon()}
        </div>
      )}
    </div>
  );
};
